import React, {useEffect, useState} from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import CardLayout from "../Layout/CardLayout";
import axiosInstance from "../../../api/api";

const PerfilMercadoForm = (ciemId) => {
    const [formData, setFormData] = useState({
        ciemId:ciemId.ciemId,
        mercadoAtendido: "Consumidor final",
        pais: "Colombia",
        ciudades: "Bogotá, Medellín",
        genero: "Masculino",
        edad: "30",
        ingresos: "3000 USD",
        educacion: "Universitaria",
        ocupacion: "Ingeniero",
        integrantesFamilia: "4",
        habitoConsumo: "Mensual",
        localizacion: "Urbana",
        claveEscogencia: "Precio",
        claveEscogenciaOtra: "",
        clientePermanente: "20%",
        clienteEsporadico: "80%",
        tiendaFisica: "",
        tiendaVirtual: "",
        visitaAsesor: "",
        otraCompra: "",
        cualCompra: "",
        efectivo:"",
        tarjetaCredito:"",
        recaudoelectronico:"",
        cartaCredito:"",
        razonCompra:"",
        sistemaPago: "Tarjeta de crédito",
        hora:"",
        dia:"",
        semana:"",
        mes:"",
        ano:"",
        influenciasCompra: {
            religion: "No",
            procedencia: "No",
            cultura: "No",
            etnia: "No",
            educacion: "No",
            politica: "No",
        },
    });

    const fetchData = async () => {
        try {
            const response = await axiosInstance.get('/demanda/mercado/'+ciemId.ciemId); // Reemplaza con la URL de tu API
            if(response.data.data) {
                setFormData(response.data.data);
            }
            console.log("Perfil Mercado")
            console.log(formData)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => { // Reemplaza con la URL de tu API de títulos
        fetchData();
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleInfluenciasChange = (e) => {
        setFormData({
            ...formData,
            influenciasCompra: { ...formData.influenciasCompra, [e.target.name]: e.target.value },
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        formData.ciemId = ciemId.ciemId
        try {
            await axiosInstance.post(`/demanda/`,formData); // Reemplaza con la URL de tu API
            fetchData();
        } catch (error) {
            alert('Error creando Perfil de la demanda :', error);
        }
        console.log(formData);
    };

    const perfilMercado =<Container>
        <Form onSubmit={handleSubmit}>
            <Form.Group>
                <Form.Label>Mercado Atendido</Form.Label>
                <Form.Control as="select" name="mercadoAtendido" onChange={handleChange} value={formData.mercadoAtendido}>
                    <option>Consumidor final</option>
                    <option>Institucional</option>
                    <option>Intersectorial</option>
                    <option>Todos</option>
                </Form.Control>
            </Form.Group>

            <Row>
                <Col>
                    <Form.Group>
                        <Form.Label>País</Form.Label>
                        <Form.Control type="text" name="pais" value={formData.pais} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Ciudades</Form.Label>
                        <Form.Control type="text" name="ciudades" value={formData.ciudades} onChange={handleChange} />
                    </Form.Group>
                </Col>
            </Row>

            <h4>Segmentación</h4>
            <Row>
                <Col>
                    <Form.Group>
                        <Form.Label>Género</Form.Label>
                        <Form.Control type="text" name="genero" value={formData.genero} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Edad</Form.Label>
                        <Form.Control type="text" name="edad" value={formData.edad} onChange={handleChange} />
                    </Form.Group>
                </Col>
            </Row>
            <Form.Group>
                <Form.Label>Ingresos mensuales</Form.Label>
                <Form.Control type="text" name="ingresos" value={formData.ingresos} onChange={handleChange} />
            </Form.Group>

            <Form.Group>
                <Form.Label>Educación</Form.Label>
                <Form.Control type="text" name="educacion" value={formData.educacion} onChange={handleChange} />
            </Form.Group>

            <Form.Group>
                <Form.Label>Ocupación</Form.Label>
                <Form.Control type="text" name="ocupacion" value={formData.ocupacion} onChange={handleChange} />
            </Form.Group>

            <Form.Group>
                <Form.Label>Número promedio integrantes por familia</Form.Label>
                <Form.Control type="text" name="integrantesFamilia" value={formData.integrantesFamilia} onChange={handleChange} />
            </Form.Group>

            <Form.Group>
                <Form.Label>Hábito de consumo del producto </Form.Label>
                <Form.Control type="text" name="habitoConsumo" value={formData.habitoConsumo} onChange={handleChange} />
            </Form.Group>

            <Form.Group>
                <Form.Label>Localización</Form.Label>
                <Form.Select name="localizacion" value={formData.localizacion} onChange={handleChange}>
                    <option value="">Seleccione una opción</option>
                    <option value="Urbana">Urbana</option>
                    <option value="Rural">Rural</option>
                </Form.Select>
            </Form.Group>

            <Form.Group>
                <Form.Label>Clave  de escogencia del producto por parte del cliente</Form.Label>
                <Form.Select name="claveEscogencia" value={formData.claveEscogencia} onChange={handleChange}>
                    <option value="">Seleccione una opción</option>
                    <option value="Precio">Precio</option>
                    <option value="Prestigio">Prestigio</option>
                    <option value="Disponibilidad">Disponibilidad</option>
                    <option value="Otra">Otra</option>
                </Form.Select>
            </Form.Group>

            {formData.claveEscogencia === 'Otra' && (
            <Form.Group>
                <Form.Label> Cuál?</Form.Label>
                <Form.Control type="text" name="claveEscogenciaOtra" value={formData.claveEscogenciaOtra} onChange={handleChange} />
            </Form.Group>
            )}

            <p></p>
            <p><h4>Tipo de Comprador</h4></p>
            <Row>
                <Col>
            <Form.Group>
                <Form.Label>Cliente permanente</Form.Label>
                <Form.Control type="text" name="clientePermanente" value={formData.clientePermanente} onChange={handleChange} />
            </Form.Group>
                </Col>
            <Col>
            <Form.Group>
                <Form.Label>Comprador esporádico</Form.Label>
                <Form.Control type="text" name="clienteEsporadico" value={formData.clienteEsporadico} onChange={handleChange} />
            </Form.Group>
            </Col>
            </Row>

            <p></p>
            <p><h4>Forma de compra y porcentaje</h4></p>
            <Row>
                <Col>
                    <Form.Group>
                        <Form.Label>Tienda física</Form.Label>
                        <Form.Control type="text" name="tiendaFisica" value={formData.tiendaFisica} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Tienda virtual con envío</Form.Label>
                        <Form.Control type="text" name="tiendaVirtual" value={formData.tiendaVirtual} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Visita vendedor o asesor</Form.Label>
                        <Form.Control type="text" name="visitaAsesor" value={formData.visitaAsesor} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Otra forma</Form.Label>
                        <Form.Control type="text" name="otraCompra" value={formData.otraCompra} onChange={handleChange} />
                    </Form.Group>
                </Col>
            </Row>
            {formData.otraCompra !== '' && (
            <Row>
                <Form.Group>
                    <Form.Label>Cuál</Form.Label>
                    <Form.Control type="text" name="cualCompra" value={formData.cualCompra} onChange={handleChange} />
                </Form.Group>
            </Row>
                )}

            <p></p>
            <p><h4>Sistema de pago</h4></p>
            <Row>
                <Col>
                    <Form.Group>
                        <Form.Label>Efectivo o contado</Form.Label>
                        <Form.Control type="text" name="efectivo" value={formData.efectivo} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Tarjeta de crédito</Form.Label>
                        <Form.Control type="text" name="tarjetaCredito" value={formData.tarjetaCredito} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Recaudo electrónico prepago</Form.Label>
                        <Form.Control type="text" name="recaudoelectronico" value={formData.recaudoelectronico} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Carta de crédito </Form.Label>
                        <Form.Control type="text" name="cartaCredito" value={formData.cartaCredito} onChange={handleChange} />
                    </Form.Group>
                </Col>
            </Row>

            <p></p>
            <p><h4>Razones de Compra</h4></p>
            <Form.Group>
                <Form.Label>Razon</Form.Label>
                <Form.Select name="razonCompra" value={formData.razonCompra} onChange={handleChange}>
                    <option value="">Seleccione una opción</option>
                    <option value="Necesidad">Necesidad</option>
                    <option value="Placer">Placer</option>
                </Form.Select>
            </Form.Group>

            <p></p>
            <p><h4>Tiempo para reposición de producto</h4></p>
            <Row>
                <Col>
                    <Form.Group>
                        <Form.Label>horas</Form.Label>
                        <Form.Control type="text" name="hora" value={formData.hora} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Días</Form.Label>
                        <Form.Control type="text" name="dia" value={formData.dia} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Semanas</Form.Label>
                        <Form.Control type="text" name="semana" value={formData.semana} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Meses</Form.Label>
                        <Form.Control type="text" name="mes" value={formData.mes} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Años</Form.Label>
                        <Form.Control type="text" name="ano" value={formData.ano} onChange={handleChange} />
                    </Form.Group>
                </Col>
            </Row>


            <p></p>
            <p><h4>Factores que influyen en la compra</h4></p>
            <Row>
            {Object.keys(formData.influenciasCompra).map((factor) => (
                <Col md={3} key={factor}>
                <Form.Group >
                    <Form.Label>{factor.charAt(0).toUpperCase() + factor.slice(1)}</Form.Label>
                    <Form.Check
                        type="radio"
                        label="Sí"
                        name={factor}
                        value="Sí"
                        checked={formData.influenciasCompra[factor] === "Sí"}
                        onChange={handleInfluenciasChange}
                    />
                    <Form.Check
                        type="radio"
                        label="No"
                        name={factor}
                        value="No"
                        checked={formData.influenciasCompra[factor] === "No"}
                        onChange={handleInfluenciasChange}
                    />
                </Form.Group>
                </Col>
            ))}
            </Row>
<p></p>
            <Button variant="primary" type="submit">Enviar</Button>
        </Form>
    </Container>

    return (
        <div className="container-fluid">
            <CardLayout value={"perfilMercadoTitulo"} tablaComponent={perfilMercado}/>
        </div>
    );
};

export default PerfilMercadoForm;
